import { defaultTemplateName, defaultTemplateNameAbbreviation } from "../../config/defaults";
import unEscapeXml from "./helpers/unEscapeXml";

//$2 matches template name
const projectNameRegex = /<Liquid\s[^>]*?Name=(['"`])([^\n\r]*?[^\s][^\n\r]*?)\1/;
const projectTemplateNameRegex = /<Liquid\s[^>]*?TN=(['"`])([^\n\r]*?[^\s][^\n\r]*?)\1/;

const parseProjectNameFromXmlString = (xmlString) => {
    const regexMatch = projectNameRegex.exec(xmlString);
    if(!regexMatch) {
        return defaultTemplateName;
    }
    return regexMatch[2];
}

const parseProjectTemplateNameFromXmlString = (xmlString) => {
    const regexMatch = projectTemplateNameRegex.exec(xmlString);
    if(!regexMatch) {
        return defaultTemplateNameAbbreviation;
    }
    return regexMatch[2];
}

/**
 * 
 * @param {string} xmlString 
 */
export function getGlobalName(xmlString) {
    const name = parseProjectNameFromXmlString(xmlString);
    return unEscapeXml(name);
}

/**
 * 
 * @param {string} xmlString 
 */
export function getGlobalTemplateName(xmlString) {
    const name = parseProjectTemplateNameFromXmlString(xmlString);
    return unEscapeXml(name);
}